const config = {
  objMaps: {
    RollbackApply: { modalTitle: '打回发起人', actionType: '204' }, // 打回
    Recall: { confirmTitle: '确定要撤回审批吗', content: '确认后该审批将被撤回', actionType: '203' }, // 撤回
    Withdraw: { confirmTitle: '确定要撤销申请吗', content: '撤销后当前流程将终止', actionType: '101' }, // 撤销
    Modify: { confirmTitle: '确定要发起修改吗', content: '修改审批中的审批单将会撤回当前审批单，再次发起审核', actionType: '102' }, // 修改
    Comment: { modalTitle: '评论', actionType: '301' }, // 评论
    Agree: { modalTitle: '审批同意意见', actionType: '201' }, // 同意
    Refuse: { modalTitle: '审批拒绝意见', actionType: '202' }, // 拒绝
    AddAudit: { modalTitle: '加签', actionType: '206' }, // 加签
    TransferAudit: { modalTitle: '转交', actionType: '207' }, // 转交
    Rollback: { modalTitle: '退回', actionType: '205' }, // 退回
    WithdrawModify: { confirmTitle: '确定要撤销修改申请吗', content: ' 确认后修改申请将被撤销', actionType: '103' }, // 撤销修改
    EditSubmit: { confirmTitle: '修改提交', content: '确定要修改提交吗', actionType: '102' },
    RollbackApplySubmit: { confirmTitle: '提示', content: '确定要重新提交吗', actionType: '104' }
  },
  CopyerObjMap: { 1: 'list', 2: 'list', 3: 'list', 4: 'bmDirector', 5: 'zsDirector' },
  CopyerChildObjMap: { 1: 'person', 2: 'department', 3: 'role' },
  instStatusMap: { 1: '审批中', 2: '审批通过', 3: '审批不通过', 4: '已撤销' }
};
export { config };
